import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from 'Components';
import NavDesktopItem from '../NavDesktopItem/NavDesktopItem';

const NavDesktopItemsAll = ({
  options,
  filterItemValue,
  togglePin,
  onViewMore,
  viewMore,
}) => {
  const { t } = useTranslation();
  return (
    <header className="nav__desktop__items__all">
      <ul>
        { options.map(option => (
          <NavDesktopItem
            {...option}
            key={option.value}
            filterItemValue={option.value}
            isActive={filterItemValue === option.value}
            togglePin={togglePin}
          />
      ))}
      </ul>
      <Button className="nav__desktop__items__all__show-more" onClick={onViewMore}>
        {viewMore ? t('nav:Fewer') : t('nav:More')} {t('nav:Projects')}
      </Button>
    </header>
  );
};

NavDesktopItemsAll.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    isPinned: PropTypes.bool,
  })),
  filterItemValue: PropTypes.string,
  togglePin: PropTypes.func,
  onViewMore: PropTypes.func,
  viewMore: PropTypes.bool,
};

export default NavDesktopItemsAll;



// WEBPACK FOOTER //
// ./src/containers/Nav/NavDesktop/NavDesktopItemsAll/NavDesktopItemsAll.jsx